import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	IconButton,
	Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ImagePreviewDialog = ({ open, onClose, selectedImage }) => (
	<Dialog
		open={open}
		onClose={onClose}
		maxWidth="lg"
		fullWidth
		slotProps={{
			paper: {
				sx: {
					m: { xs: 1, md: 4 },
					maxHeight: "90vh",
				},
			},
		}}
	>
		<DialogTitle>
			Snapshot
			<IconButton
				aria-label="close"
				onClick={onClose}
				style={{ position: "absolute", right: 8, top: 8 }}
			>
				<CloseIcon />
			</IconButton>
		</DialogTitle>
		<Divider style={{ marginBottom: 10 }} />
		<DialogContent style={{ textAlign: "center", padding: 8 }}>
			{selectedImage && (
				<img
					src={selectedImage}
					alt="Selected-Snapshot"
					style={{
						maxWidth: "100%",
						maxHeight: "75vh",
						objectFit: "contain",
					}}
				/>
			)}
		</DialogContent>
	</Dialog>
);

export default ImagePreviewDialog;
